<template>
    <div class="py-4 container-fluid">
        <div class="d-flex gap-3 align-items-start" style="height: calc(100vh - 120px);">
            <!-- Asset Explorer Panel (Kiri) -->
            <AssetExplorer
ref="explorer" :categories="categories" :loading="loading" @select-item="onSelectItem"
                @load-children="onLoadChildren" @add-asset="openAddModal" @select-folder="onSelectFolder"
                @search="onSearch" />

            <!-- Main Card (Kanan) -->
            <div class="flex-grow-1 h-100 overflow-hidden">
                <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                    <div
                        class="card-header py-3 bg-white border-bottom d-flex justify-content-between align-items-center">
                        <div>
                            <h5 class="mb-0 fw-bold" style="color: #1e293b;">
                                {{ activeAsset ? activeAsset.label : 'Asset Management' }}
                            </h5>
                            <span class="text-muted" style="font-size: 0.85rem;">
                                {{ activeAsset ? activeAsset.asset_code : 'Select an asset to view details' }}
                            </span>
                        </div>
                        <div class="d-flex gap-2">
                            <button
type="button"
                                class="mb-0 btn btn-sm btn-outline-primary d-flex align-items-center gap-1 py-1 px-2">
                                <i class="pi pi-file-export" style="font-size: 0.7rem;"></i>
                                <span style="font-size: 0.75rem;">Export</span>
                            </button>
                            <button
v-if="activeAsset" type="button"
                                class="mb-0 btn btn-sm btn-outline-secondary d-flex align-items-center gap-1 py-1 px-2"
                                @click="openEditModal(activeAsset)">
                                <i class="pi pi-pencil" style="font-size: 0.7rem;"></i>
                                <span style="font-size: 0.75rem;">Update</span>
                            </button>
                            <button
v-if="activeAsset" type="button"
                                class="mb-0 btn btn-sm btn-outline-danger d-flex align-items-center gap-1 py-1 px-2"
                                @click="deleteAsset(activeAsset.asset_code)">
                                <i class="pi pi-trash" style="font-size: 0.7rem;"></i>
                                <span style="font-size: 0.75rem;">Delete</span>
                            </button>
                        </div>
                    </div>
                    <div class="card-body p-0" style="flex: 1; overflow: hidden;">
                        <!-- Skeleton Loading State -->
                        <div v-if="detailLoading" class="h-100 overflow-auto p-4 bg-white">
                            <div class="d-flex justify-content-between align-items-start mb-4">
                                <Skeleton width="60%" height="1.5rem" />
                                <Skeleton width="80px" height="1.2rem" border-radius="16px" />
                            </div>
                            <div class="row g-3 mb-4">
                                <div v-for="n in 4" :key="n" class="col-6">
                                    <Skeleton width="40%" height="0.7rem" class="mb-2" />
                                    <Skeleton width="80%" height="1rem" />
                                </div>
                            </div>
                            <div class="mb-4">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <Skeleton width="120px" height="0.9rem" />
                                    <Skeleton width="60px" height="1.5rem" border-radius="6px" />
                                </div>
                                <Skeleton width="100%" height="200px" />
                            </div>
                        </div>

                        <div v-else-if="selectedItemObj" class="h-100">
                            <div class="row g-0 h-100">
                                <div v-if="selectedItemObj.image" class="col-md-7 col-lg-8 h-100 border-end">
                                    <AssetExplodedView
:asset="selectedItemObj" :parts="partsData"
                                        :selected-part="selectedPart" @select-part="onSelectPart" />
                                </div>

                                <div
:class="selectedItemObj.image ? 'col-md-5 col-lg-4' : 'col-12'"
                                    class="h-100 overflow-auto p-4 bg-white">
                                    <div class="d-flex justify-content-between align-items-start mb-4">
                                        <h2
class="mb-0 fw-bold tracking-tight"
                                            style="color: #0f172a; font-size: 1.20rem;">
                                            {{ selectedItemObj.label }}
                                        </h2>
                                        <span
                                            class="badge bg-success-subtle text-success border border-success d-flex align-items-center gap-2 rounded-pill px-3 py-2"
                                            style="font-size: 0.55rem;">Operational</span>
                                    </div>

                                    <div class="row g-3 mb-4">
                                        <div class="col-6">
                                            <label class="industrial-label ms-2">ASSET CODE</label>
                                            <div class="industrial-value ms-2">{{ selectedItemObj.asset_code || '-' }}
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <label class="industrial-label ms-2">MODEL</label>
                                            <div class="industrial-value ms-2">{{ selectedItemObj.model || '-' }}</div>
                                        </div>
                                        <div class="col-6">
                                            <label class="industrial-label ms-2">Manufacturer</label>
                                            <div class="industrial-value ms-2">{{ selectedItemObj.manufacturer || '-' }}
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <label class="industrial-label ms-2">Serial Number</label>
                                            <div class="industrial-value ms-2">{{ selectedItemObj.serial_number || '-'
                                                }}</div>
                                        </div>
                                    </div>

                                    <div class="mb-4">
                                        <div class="d-flex justify-content-between align-items-center mb-0">
                                            <span class="fw-semibold" style="font-size: 0.85rem;">Bill of Materials
                                                (BOM)</span>
                                            <button
                                                v-if="selectedItemObj.asset_type === 'equipment' || selectedItemObj.asset_type === 'sub_equipment'"
                                                type="button"
                                                class="btn btn-sm btn-primary d-flex align-items-center gap-1 py-1 px-2"
                                                @click="openAddMaterialModal">
                                                <i class="pi pi-plus" style="font-size: 0.7rem;"></i>
                                                <span style="font-size: 0.75rem;">Add</span>
                                            </button>
                                        </div>
                                        <div class="rounded-2">
                                            <DataTable
v-model:selection="selectedPart" :value="partsLoading ? partsLoadingRows : partsData"
                                                scrollable scroll-height="450px"
                                                table-style="min-width: 100%;" class="p-datatable-sm"
                                                selection-mode="single" data-key="material_number"
                                                @row-select="onSelectPart($event.data)">
                                                <Column
field="material_number" header="Material No"
                                                    header-class="bg-light text-nowrap text-dark" sortable>
                                                    <template v-if="partsLoading" #body>
                                                        <Skeleton />
                                                    </template>
                                                    <template v-else #body="slotProps">
                                                        <span style="font-size: 0.85rem;" class="fw-semibold">{{
                                                            slotProps.data.material_number }}</span>
                                                    </template>
                                                </Column>
                                                <Column
field="part_description" header="Description"
                                                    header-class="bg-light text-nowrap text-dark" sortable
                                                    style="min-width: 500px;">
                                                    <template v-if="partsLoading" #body>
                                                        <Skeleton />
                                                    </template>
                                                    <template v-else #body="slotProps">
                                                        <span style="font-size: 0.80rem;">{{
                                                            slotProps.data.part_description }}</span>
                                                    </template>
                                                </Column>
                                                <Column
field="position" header="Position"
                                                    header-class="bg-light text-nowrap text-dark" sortable>
                                                    <template v-if="partsLoading" #body>
                                                        <Skeleton />
                                                    </template>
                                                    <template v-else #body="slotProps">
                                                        <span style="font-size: 0.85rem;">{{ slotProps.data.position
                                                            }}</span>
                                                    </template>
                                                </Column>
                                                <Column
field="qty_installed" header="QTY"
                                                    header-class="bg-light text-nowrap text-dark text-center" sortable>
                                                    <template v-if="partsLoading" #body>
                                                        <Skeleton />
                                                    </template>
                                                    <template v-else #body="slotProps">
                                                        <div class="text-center w-100">
                                                            <span
class="badge bg-secondary px-2 py-1"
                                                                style="font-size: 0.75rem;">{{
                                                                slotProps.data.qty_installed }}</span>
                                                        </div>
                                                    </template>
                                                </Column>
                                                <Column
field="uom" header="UOM"
                                                    header-class="bg-light text-nowrap text-dark" sortable>
                                                    <template v-if="partsLoading" #body>
                                                        <Skeleton />
                                                    </template>
                                                    <template v-else #body="slotProps">
                                                        <span style="font-size: 0.85rem;">{{ slotProps.data.uom
                                                            }}</span>
                                                    </template>
                                                </Column>
                                                <Column
header="Action"
                                                    header-class="bg-light text-nowrap text-dark text-center" style="min-width: 100px;">
                                                    <template v-if="partsLoading" #body>
                                                        <Skeleton />
                                                    </template>
                                                    <template v-else #body="slotProps">
                                                        <div class="text-center">
                                                            <ButtonPrime
v-tooltip.bottom="'Update'" icon="pi pi-pencil" outlined
                                                                rounded size="small"
                                                                class="me-2"
                                                                @click="openEditMaterialModal(slotProps.data)" />
                                                            <ButtonPrime
v-tooltip.bottom="'Delete'" icon="pi pi-trash" outlined
                                                                rounded severity="danger"
                                                                size="small"
                                                                @click="deleteMaterial(slotProps.data.asset_code)" />
                                                        </div>
                                                    </template>
                                                </Column>
                                                <template #empty>
                                                    <div style="text-align: center; padding: 40px 0;">
                                                        <img
src="/no_data.png" alt="No Data"
                                                            style="max-width: 100px; opacity: 0.7; margin-bottom: 0;" />
                                                        <div style="color: #888; font-size: 1.1em; font-weight: 500;">
                                                            No Data
                                                        </div>
                                                    </div>
                                                </template>
                                            </DataTable>
                                        </div>
                                    </div>
                                    <div
                                        class="mt-auto pt-3 border-top d-flex justify-content-between align-items-center">
                                        <div class="text-muted" style="font-size: 0.70rem;">
                                            <span>Showing {{ partsData.length }} BOM items</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
v-else
                            class="h-100 d-flex flex-column align-items-center justify-content-center text-muted">
                            <i class="pi pi-inbox mb-3" style="font-size: 4rem; opacity: 0.2;"></i>
                            <h5 class="fw-bold">No Asset Selected</h5>
                            <p>Select a mechanical part from the explorer to view its full technical details</p>
                        </div>
                        <!-- v-if chain closed above -->
                    </div>
                </div>
            </div>
        </div>

        <!-- Asset Dialog (Add / Edit) -->
        <DialogPrime
v-model:visible="modal.visible" modal
            :style="{ width: isEquipmentType ? '35rem' : (modal.type === 'material' ? '40rem' : '30rem'), margin: '10px' }">
            <template #header>
                <div class="d-flex align-items-center gap-3">
                    <h5 class="mb-0 fw-bold text-dark">{{ modalTitle }}</h5>
                </div>
            </template>
            <div class="row g-3">
                <!-- Parent (read-only) -->
                <!-- <div v-if="modal.parentNode" class="col-12">
                    <label class="form-label fw-semibold">Parent</label>
                    <InputText :model-value="`${modal.parentNode.asset_code} - ${modal.parentNode.label}`" disabled
                        fluid />
                </div> -->

                <!-- Asset Code (hidden for material on create — backend generates it) -->
                <div
v-if="!(modal.type === 'material' && modal.action === 'create')"
                    :class="isEquipmentType || modal.type === 'material' ? 'col-6' : 'col-12'">
                    <label for="asset_code" class="form-label fw-semibold">Asset Code <span
                            class="text-danger">*</span></label>
                    <InputText
id="asset_code" v-model="modal.data.asset_code" :placeholder="assetCodePlaceholder"
                        :class="modal.errorMessage['asset_code'] ? 'border-danger' : ''"
                        :disabled="modal.action === 'update'" fluid />
                    <small v-if="modal.errorMessage['asset_code']" class="text-danger">{{
                        modal.errorMessage['asset_code']
                        }}</small>
                </div>

                <!-- Asset Name -->
                <div :class="isEquipmentType || modal.type === 'material' ? 'col-6' : 'col-12'">
                    <label for="asset_name" class="form-label fw-semibold">Asset Name <span
                            class="text-danger">*</span></label>
                    <InputText
id="asset_name" v-model="modal.data.asset_name" :placeholder="modalPlaceholder"
                        :class="modal.errorMessage['asset_name'] ? 'border-danger' : ''" fluid />
                    <small v-if="modal.errorMessage['asset_name']" class="text-danger">{{
                        modal.errorMessage['asset_name']
                        }}</small>
                </div>

                <!-- Equipment / Sub-Equipment fields -->
                <template v-if="isEquipmentType">
                    <div class="col-6">
                        <label class="form-label fw-semibold">Manufacturer</label>
                        <InputText v-model="modal.data.equipment_manufacturer" placeholder="e.g. SIEMENS" fluid />
                    </div>
                    <div class="col-6">
                        <label class="form-label fw-semibold">Model</label>
                        <InputText v-model="modal.data.equipment_model" placeholder="e.g. V3-TURBO" fluid />
                    </div>
                    <div class="col-12">
                        <label class="form-label fw-semibold">Serial Number</label>
                        <InputText v-model="modal.data.equipment_serial_number" placeholder="e.g. SN-998822" fluid />
                    </div>
                    <div class="col-12">
                        <label class="form-label fw-semibold">Image</label>
                        <input
ref="imageInput" type="file" class="form-control form-control"
                            accept="image/png,image/jpeg" @change="onImageSelect" />
                        <small v-if="modal.errorMessage['images']" class="text-danger">{{ modal.errorMessage['images']
                            }}</small>
                    </div>
                </template>

                <!-- Material fields -->
                <template v-if="modal.type === 'material'">
                    <div class="col-6">
                        <label class="form-label fw-semibold">Material Number (KIMAP) <span
                                class="text-danger">*</span></label>
                        <InputText
v-model="modal.data.material_number" placeholder="e.g. KIMAP-9921"
                            :class="modal.errorMessage['material_number'] ? 'border-danger' : ''" fluid />
                        <small v-if="modal.errorMessage['material_number']" class="text-danger">{{
                            modal.errorMessage['material_number'] }}</small>
                    </div>
                    <div class="col-6">
                        <label class="form-label fw-semibold">Drawing No <span class="text-danger">*</span></label>
                        <InputText
v-model="modal.data.drawing_no" placeholder="e.g. DWG-001"
                            :class="modal.errorMessage['drawing_no'] ? 'border-danger' : ''" fluid />
                        <small v-if="modal.errorMessage['drawing_no']" class="text-danger">{{
                            modal.errorMessage['drawing_no'] }}</small>
                    </div>
                    <div class="col-6">
                        <label class="form-label fw-semibold">Position</label>
                        <InputText
v-model="modal.data.position" placeholder="e.g. Drive End"
                            :class="modal.errorMessage['position'] ? 'border-danger' : ''" fluid />
                        <small v-if="modal.errorMessage['position']" class="text-danger">{{
                            modal.errorMessage['position'] }}</small>
                    </div>
                    <div class="col-6">
                        <label class="form-label fw-semibold">QTY Installed</label>
                        <InputText
v-model="modal.data.qty_installed" type="number" placeholder="e.g. 2"
                            :class="modal.errorMessage['qty_installed'] ? 'border-danger' : ''" fluid />
                        <small v-if="modal.errorMessage['qty_installed']" class="text-danger">{{
                            modal.errorMessage['qty_installed'] }}</small>
                    </div>
                    <div class="col-6">
                        <label class="form-label fw-semibold">UOM <span class="text-danger">*</span></label>
                        <InputText
v-model="modal.data.uom" placeholder="e.g. PCS"
                            :class="modal.errorMessage['uom'] ? 'border-danger' : ''" fluid />
                        <small v-if="modal.errorMessage['uom']" class="text-danger">{{ modal.errorMessage['uom']
                            }}</small>
                    </div>
                    <div class="col-6">
                        <label class="form-label fw-semibold">Doc Page <span class="text-danger">*</span></label>
                        <InputText
v-model="modal.data.doc_page" type="number" placeholder="e.g. 12"
                            :class="modal.errorMessage['doc_page'] ? 'border-danger' : ''" fluid />
                        <small v-if="modal.errorMessage['doc_page']" class="text-danger">{{
                            modal.errorMessage['doc_page'] }}</small>
                    </div>
                    <div class="col-12">
                        <label class="form-label fw-semibold">Part Description <span
                                class="text-danger">*</span></label>
                        <textarea
v-model="modal.data.part_description" placeholder="e.g. Deep groove ball bearing"
                            :class="modal.errorMessage['part_description'] ? 'border-danger' : ''" class="form-control" rows="3"></textarea>
                        <small v-if="modal.errorMessage['part_description']" class="text-danger">{{
                            modal.errorMessage['part_description'] }}</small>
                    </div>
                    <div class="col-12">
                        <label class="form-label fw-semibold">
                            Document Reference (PDF)
                            <span v-if="modal.action === 'create'" class="text-danger">*</span>
                            <small v-else class="text-muted">(leave empty to keep existing)</small>
                        </label>
                        <input
ref="docInput" type="file" class="form-control form-control" accept="application/pdf"
                            @change="onDocSelect" />
                        <small v-if="modal.errorMessage['doc_reference']" class="text-danger">{{
                            modal.errorMessage['doc_reference'] }}</small>
                    </div>
                </template>
            </div>
            <template #footer>
                <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
                    <ButtonPrime
type="button" label="Cancel" severity="danger" raised size="small"
                        class="px-4 border-0" @click="closeModal()" />
                    <ButtonPrime
type="button" severity="contrast" raised size="small" :disabled="modal.onLoading"
                        label="Save" class="px-4" @click="save()">
                        <template v-if="modal.onLoading" #icon>
                            <i class="fas fa-spinner fa-spin me-2"></i>
                        </template>
                    </ButtonPrime>
                </div>
            </template>
        </DialogPrime>
    </div>
</template>

<script>
import AssetExplorer from "./components/AssetExplorer.vue";
import AssetExplodedView from "./components/AssetExplodedView.vue";
import assetsManagementService from "@/services/assetsManagement/assetsManagementService";
import api from "@/helpers/api";
import setMaxSize from "@/helpers/setMaxSize";

const EMPTY_MODAL_DATA = {
    asset_code: '',
    asset_name: '',
    equipment_manufacturer: '',
    equipment_model: '',
    equipment_serial_number: '',
    material_number: '',
    drawing_no: '',
    position: '',
    part_description: '',
    qty_installed: '',
    uom: '',
    doc_page: '',
};

const TYPE_META = {
    funcloc: { title: 'Functional Location', codePlaceholder: 'e.g. FLC-001', namePlaceholder: 'e.g. COOLING WATER HEADER TANK' },
    system: { title: 'System', codePlaceholder: 'e.g. SYS-001', namePlaceholder: 'e.g. Cooling System Line 1' },
    equipment: { title: 'Equipment', codePlaceholder: 'e.g. EQP-001', namePlaceholder: 'e.g. Electric Motor 45KW' },
    sub_equipment: { title: 'Sub-Equipment', codePlaceholder: 'e.g. SEQP-001', namePlaceholder: 'e.g. Sub Motor 11KW' },
    material: { title: 'Material / Sparepart', codePlaceholder: 'e.g. MAT-001', namePlaceholder: 'e.g. Bearing DE' },
};

export default {
    components: { AssetExplorer, AssetExplodedView },
    data() {
        return {
            selectedItemObj: null,
            selectedFolderObj: null,
            selectedPart: null,
            partsData: [],
            partsLoading: false,
            detailLoading: false,
            categories: [],
            loading: false,
            modal: {
                visible: false,
                action: 'create',            // 'create' | 'update'
                type: 'funcloc',             // funcloc | system | equipment | sub_equipment | material
                parentNode: null,
                editAssetCode: null,
                data: { ...EMPTY_MODAL_DATA },
                imageFile: null,
                docFile: null,
                errorMessage: {},
                onLoading: false,
            },
            maxValidation: {
                size: 2000000,
                text: "Max Size 2000 KB"
            },
        };
    },
    computed: {
        isEquipmentType() {
            return this.modal.type === 'equipment' || this.modal.type === 'sub_equipment';
        },
        modalTitle() {
            const verb = this.modal.action === 'update' ? 'Edit' : 'Add';
            return `${verb} ${TYPE_META[this.modal.type]?.title || 'Asset'}`;
        },
        modalPlaceholder() {
            return TYPE_META[this.modal.type]?.namePlaceholder || '';
        },
        assetCodePlaceholder() {
            return TYPE_META[this.modal.type]?.codePlaceholder || '';
        },
        partsLoadingRows() {
            return Array.from({ length: 5 }, () => ({}));
        },
        activeAsset() {
            return this.selectedItemObj || this.selectedFolderObj;
        },
    },
    mounted() {
        this.fetchAssets().then(() => this.restoreFromQuery());
        this.getMaxSizeConfig();
    },
    methods: {
        // ============ Fetch & Tree ============
        async fetchAssets(search = "") {
            this.loading = true;
            try {
                const res = await assetsManagementService.list({ search });
                this.categories = (res.data?.data || []).map(a => this.mapAssetToNode(a));
            } catch (e) {
                console.error("Failed to fetch assets:", e);
            } finally {
                this.loading = false;
            }
        },
        onSearch(keyword) {
            this.fetchAssets(keyword);
        },
        mapAssetToNode(asset) {
            const isFolder = asset.asset_type === "funcloc" || asset.asset_type === "system";
            const isEquipmentLike = asset.asset_type === "equipment" || asset.asset_type === "sub_equipment";
            const expandable = isFolder || (isEquipmentLike && asset.has_sub_equipment === true);
            return {
                id: asset.id,
                label: asset.asset_name,
                icon: isFolder ? "pi pi-folder" : "pi pi-cog",
                open: false,
                asset_code: asset.asset_code,
                asset_type: asset.asset_type,
                description: asset.part_description,
                image: asset.drawing_no,
                manufacturer: asset.equipment_manufacturer,
                model: asset.equipment_model,
                serial_number: asset.equipment_serial_number,
                material_number: asset.material_number,
                qty: asset.qty_installed,
                uom: asset.uom,
                has_sub_equipment: asset.has_sub_equipment === true,
                has_children: expandable,
                children: expandable ? [] : undefined,
                loading: false,
            };
        },
        async onLoadChildren(node) {
            if (node.loading) return;
            node.loading = true;
            try {
                const res = await assetsManagementService.detail(node.asset_code);
                const children = res.data?.data?.children || [];
                const isEquipmentLike = node.asset_type === "equipment" || node.asset_type === "sub_equipment";
                // Equipment/sub_equipment only show sub_equipment in tree; materials live in the right panel.
                const visible = isEquipmentLike
                    ? children.filter(c => c.asset_type === "sub_equipment")
                    : children;
                node.children = visible.map(c => this.mapAssetToNode(c));
            } catch (e) {
                console.error("Failed to load children:", e);
            } finally {
                node.loading = false;
            }
        },
        findNode(nodes, assetCode) {
            if (!nodes) return null;
            for (const n of nodes) {
                if (n.asset_code === assetCode) return n;
                if (n.children?.length) {
                    const found = this.findNode(n.children, assetCode);
                    if (found) return found;
                }
            }
            return null;
        },

        // ============ Selection & Query ============
        async onSelectItem(item) {
            this.selectedPart = null;
            this.partsData = [];
            this.partsLoading = true;
            this.detailLoading = true;
            this.selectedItemObj = null;
            this.selectedFolderObj = null;
            try {
                const res = await assetsManagementService.detail(item.asset_code);
                const data = res.data?.data;
                const asset = data?.asset || {};

                // Build query by walking parent chain (asset.parent is parent's asset_code string)
                const query = {};
                const visited = new Set();
                const assignToQuery = (a) => {
                    if (a.asset_type === 'funcloc') query.asset = a.asset_code;
                    else if (a.asset_type === 'system') query.system = a.asset_code;
                    else if (a.asset_type === 'equipment') query.equipment = a.asset_code;
                    else if (a.asset_type === 'sub_equipment') query.sub_equipment = a.asset_code;
                };
                assignToQuery(asset);
                let parentCode = asset.parent_asset?.asset_code || asset.parent || null;
                while (parentCode && !visited.has(parentCode)) {
                    visited.add(parentCode);
                    try {
                        const pRes = await assetsManagementService.detail(parentCode);
                        const pAsset = pRes.data?.data?.asset || {};
                        if (!pAsset.asset_code) break;
                        assignToQuery(pAsset);
                        parentCode = pAsset.parent_asset?.asset_code || pAsset.parent || null;
                    } catch (e) {
                        break;
                    }
                }
                this.updateQuery(query);

                const children = data?.children || [];
                const isUnit = asset.asset_type === 'equipment' || asset.asset_type === 'sub_equipment';

                const aggregatedMarkers = [
                    ...(asset.markers || []),
                    ...children
                        .filter(c => c.asset_type === 'material')
                        .flatMap(c => (c.markers || []).map(m => ({ ...m, asset_code: m.asset_code || c.asset_code }))),
                ];

                this.selectedItemObj = {
                    ...item,
                    label: asset.asset_name || item.label,
                    asset_code: asset.asset_code || item.asset_code,
                    asset_type: asset.asset_type,
                    manufacturer: asset.equipment_manufacturer,
                    model: asset.equipment_model,
                    serial_number: asset.equipment_serial_number,
                    image: asset.images,
                    doc_page: asset.doc_page,
                    description: asset.part_description,
                    material_number: asset.material_number,
                    qty: asset.qty_installed,
                    uom: asset.uom,
                    markers: aggregatedMarkers,
                    parent_asset_code: asset.parent_asset?.asset_code || asset.parent || null,
                };

                this.partsData = (isUnit ? children.filter(c => c.asset_type === 'material') : children)
                    .map(c => ({
                        asset_code: c.asset_code,
                        asset_name: c.asset_name,
                        asset_type: c.asset_type,
                        material_number: c.material_number,
                        part_description: c.part_description,
                        position: c.position,
                        qty_installed: c.qty_installed || '-',
                        uom: c.uom,
                        drawing_no: c.drawing_no,
                        doc_page: c.doc_page,
                    }));

                // Populate tree node children for equipment-like nodes (sub_equipment only)
                if (isUnit) {
                    const treeNode = this.findNode(this.categories, asset.asset_code);
                    if (treeNode && (!treeNode.children || treeNode.children.length === 0)) {
                        treeNode.children = children
                            .filter(c => c.asset_type === 'sub_equipment')
                            .map(c => this.mapAssetToNode(c));
                    }
                }
            } catch (e) {
                console.error("Failed to load asset detail:", e);
                this.selectedItemObj = item;
            } finally {
                this.partsLoading = false;
                this.detailLoading = false;
            }
        },
        onSelectPart(part) {
            this.selectedPart = part;
        },
        onSelectFolder(node) {
            // Reset panel kanan ke empty state saat folder (funcloc/system) diklik
            this.selectedItemObj = null;
            this.selectedPart = null;
            this.partsData = [];

            if (!node) {
                this.selectedFolderObj = null;
                return this.updateQuery({});
            }
            // Track folder yang sedang dipilih supaya Edit/Delete di header tetap muncul
            this.selectedFolderObj = node;

            const query = { ...this.$route.query };
            if (node.asset_type === 'funcloc') this.updateQuery({ asset: node.asset_code });
            else if (node.asset_type === 'system') this.updateQuery({ asset: query.asset, system: node.asset_code });
        },
        updateQuery(query) {
            this.$router.replace({ path: this.$route.path, query }).catch(() => { });
        },
        async restoreFromQuery() {
            const q = this.$route.query;
            const targetCode = q.equipment || q.system || q.asset;
            if (!targetCode) return;
            try {
                // 1. Walk parent chain. Cache every detail() response so we don't refetch later.
                const detailCache = new Map();
                const chain = [];
                let currentCode = targetCode;
                const visited = new Set();
                while (currentCode && !visited.has(currentCode)) {
                    visited.add(currentCode);
                    const res = await assetsManagementService.detail(currentCode);
                    detailCache.set(currentCode, res.data?.data);
                    const asset = res.data?.data?.asset || {};
                    if (!asset.asset_code) break;
                    chain.unshift(asset.asset_code);
                    currentCode = asset.parent_asset?.asset_code || asset.parent || null;
                }

                // 2. Kick off detail load for the target IMMEDIATELY (panel kanan langsung muncul).
                const targetNodeStub = { asset_code: targetCode, label: '' };
                const selectPromise = this.onSelectItem(targetNodeStub);

                // 3. Build/expand tree using cached responses — no sequential network calls.
                let nodes = this.categories;
                let lastNode = null;
                for (const code of chain) {
                    const node = this.findNode(nodes, code);
                    if (!node) break;
                    lastNode = node;
                    const cached = detailCache.get(code);
                    if (cached && (!node.children || node.children.length === 0)) {
                        const children = cached.children || [];
                        const isEquipmentLike = node.asset_type === "equipment" || node.asset_type === "sub_equipment";
                        const visible = isEquipmentLike
                            ? children.filter(c => c.asset_type === "sub_equipment")
                            : children;
                        node.children = visible.map(c => this.mapAssetToNode(c));
                    }
                    node.open = true;
                    nodes = node.children || [];
                }

                if (lastNode && this.$refs.explorer) {
                    this.$refs.explorer.selectedItem = lastNode.asset_code;
                    this.$refs.explorer.selectedParentNode = lastNode.has_children ? lastNode : null;
                }
                await selectPromise;
            } catch (e) {
                console.error("Failed to restore from query:", e);
            }
        },

        // ============ Modal: Open / Close ============
        resetModal() {
            this.modal.data = { ...EMPTY_MODAL_DATA };
            this.modal.imageFile = null;
            this.modal.docFile = null;
            this.modal.errorMessage = {};
            this.modal.onLoading = false;
            this.modal.parentNode = null;
            this.modal.editAssetCode = null;
            if (this.$refs.imageInput) this.$refs.imageInput.value = '';
            if (this.$refs.docInput) this.$refs.docInput.value = '';
        },
        resolveTypeFromParent(parentNode) {
            if (!parentNode) return 'funcloc';
            if (parentNode.asset_type === 'funcloc') return 'system';
            if (parentNode.asset_type === 'system') return 'equipment';
            if (parentNode.asset_type === 'equipment' || parentNode.asset_type === 'sub_equipment') return 'sub_equipment';
            return 'funcloc';
        },
        openAddModal(parentNode = null) {
            this.resetModal();
            this.modal.action = 'create';
            this.modal.type = this.resolveTypeFromParent(parentNode);
            this.modal.parentNode = parentNode;
            this.modal.visible = true;
        },
        openEditModal(item) {
            this.resetModal();
            this.modal.action = 'update';
            this.modal.type = item.asset_type || 'funcloc';
            this.modal.editAssetCode = item.asset_code;
            this.modal.data = {
                ...EMPTY_MODAL_DATA,
                asset_code: item.asset_code || '',
                asset_name: item.label || item.asset_name || '',
                equipment_manufacturer: item.manufacturer || '',
                equipment_model: item.model || '',
                equipment_serial_number: item.serial_number || '',
            };
            this.modal.visible = true;
        },
        openAddMaterialModal() {
            this.resetModal();
            this.modal.action = 'create';
            this.modal.type = 'material';
            this.modal.parentNode = this.selectedItemObj;
            this.modal.visible = true;
        },
        openEditMaterialModal(material) {
            this.resetModal();
            this.modal.action = 'update';
            this.modal.type = 'material';
            this.modal.editAssetCode = material.asset_code;
            this.modal.parentNode = this.selectedItemObj;
            this.modal.data = {
                ...EMPTY_MODAL_DATA,
                asset_code: material.asset_code || '',
                asset_name: material.asset_name || '',
                material_number: material.material_number || '',
                drawing_no: material.drawing_no || '',
                position: material.position || '',
                part_description: material.part_description || '',
                qty_installed: material.qty_installed !== '-' ? material.qty_installed : '',
                uom: material.uom || '',
                doc_page: material.doc_page || '',
            };
            this.modal.visible = true;
        },
        closeModal() {
            this.modal.visible = false;
            this.resetModal();
            this.modal.type = 'funcloc';
            this.modal.action = 'create';
        },
        onImageSelect(event) {
            const file = event.target.files[0] || null;

            if (file && !['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) {
                this.modal.errorMessage['images'] = 'Only PNG and JPEG files are allowed';
                this.modal.imageFile = null;
                this.$refs.imageInput.value = '';
                return;
            }

            if (file && file.size > this.maxValidation.size) {
                this.modal.errorMessage['images'] = this.maxValidation.text;
                this.modal.imageFile = null;
                this.$refs.imageInput.value = '';
                return;
            }

            this.modal.errorMessage['images'] = '';
            this.modal.imageFile = file;
        },
        onDocSelect(event) {
            this.modal.docFile = event.target.files[0] || null;
        },

        // ============ Save ============
        validate() {
            this.modal.errorMessage = {};
            const d = this.modal.data;
            const setErr = (k, m) => { this.modal.errorMessage[k] = m; };

            if (this.modal.action === 'create' && this.modal.type !== 'material' && !String(d.asset_code).trim()) setErr('asset_code', 'Asset Code Required');
            if (!String(d.asset_name).trim()) setErr('asset_name', 'Asset Name Required');

            if (this.modal.type === 'material') {
                const required = {
                    material_number: 'Material Number Required',
                    drawing_no: 'Drawing No Required',
                    part_description: 'Part Description Required',
                    uom: 'UOM Required',
                    doc_page: 'Doc Page Required',
                };
                for (const [k, msg] of Object.entries(required)) {
                    if (!String(d[k] ?? '').trim()) setErr(k, msg);
                }
                if (this.modal.action === 'create' && !this.modal.docFile) {
                    setErr('doc_reference', 'Document Reference Required');
                }
            }
            return Object.keys(this.modal.errorMessage).length === 0;
        },
        buildFormData() {
            const d = this.modal.data;
            const fd = new FormData();
            fd.append('asset_type', this.modal.type);
            const skipAssetCode = this.modal.type === 'material' && this.modal.action === 'create';
            if (!skipAssetCode) fd.append('asset_code', d.asset_code);
            fd.append('asset_name', d.asset_name);
            fd.append('parent', this.modal.parentNode ? this.modal.parentNode.asset_code : '');

            if (this.isEquipmentType) {
                if (d.equipment_manufacturer) fd.append('equipment_manufacturer', d.equipment_manufacturer);
                if (d.equipment_model) fd.append('equipment_model', d.equipment_model);
                if (d.equipment_serial_number) fd.append('equipment_serial_number', d.equipment_serial_number);
                if (this.modal.imageFile) fd.append('images', this.modal.imageFile);
            }

            if (this.modal.type === 'material') {
                fd.append('material_number', d.material_number);
                fd.append('drawing_no', d.drawing_no);
                fd.append('position', d.position);
                fd.append('part_description', d.part_description);
                fd.append('qty_installed', d.qty_installed);
                fd.append('uom', d.uom);
                fd.append('doc_page', d.doc_page);
                if (this.modal.docFile) fd.append('doc_reference', this.modal.docFile);
            }
            return fd;
        },
        async save() {
            if (!this.validate()) return;

            this.modal.onLoading = true;
            try {
                const formData = this.buildFormData();
                const req = this.modal.action === 'update'
                    ? assetsManagementService.update(this.modal.editAssetCode, formData)
                    : assetsManagementService.create(formData);
                await api(this, req, true);

                this.modal.visible = false;
                const wasMaterial = this.modal.type === 'material';
                this.resetModal();

                if (wasMaterial && this.selectedItemObj) {
                    this.onSelectItem(this.selectedItemObj);
                } else {
                    this.fetchAssets();
                    if (this.selectedItemObj) this.onSelectItem(this.selectedItemObj);
                }
            } catch (error) {
                if (error.response?.data?.code == 400 && error.response.data.data) {
                    error.response.data.data.forEach(v => {
                        this.modal.errorMessage[v.path] = v.msg;
                    });
                }
            } finally {
                this.modal.onLoading = false;
            }
        },

        // ============ Delete ============
        deleteAsset(assetCode) {
            this.confirmDialog("You won't be able to revert this!", "delete it").then(result => {
                if (!result.isConfirmed) return;
                api(this, assetsManagementService.delete(assetCode)).then(() => {
                    this.selectedItemObj = null;
                    this.selectedFolderObj = null;
                    this.partsData = [];
                    if (this.$refs.explorer) {
                        this.$refs.explorer.selectedItem = null;
                        this.$refs.explorer.selectedParentNode = null;
                    }
                    this.updateQuery({});
                    this.fetchAssets();
                });
            });
        },
        deleteMaterial(assetCode) {
            this.confirmDialog("You won't be able to revert this!", "delete it").then(result => {
                if (!result.isConfirmed) return;
                this.partsLoading = true;
                api(this, assetsManagementService.delete(assetCode))
                    .then(() => this.onSelectItem(this.selectedItemObj))
                    .catch(() => { this.partsLoading = false; });
            });
        },
        async getMaxSizeConfig() {
            try {
                const result = await setMaxSize();
                if (result) {
                this.maxValidation.size = result.data.data.maximum_file;
                this.maxValidation.text = `Max Size ${result.data.data.maximum_file / 1000} KB`;
                }
            } catch (error) {
                this.maxValidation.size = 2000000;
                this.maxValidation.text = `Max Size ${this.maxValidation.size / 1000} KB`;
            } 
        },
    },
};
</script>

<style scoped>
.bg-success-subtle {
    background-color: #f0fdf4 !important;
}

.text-success {
    color: #166534 !important;
}

.industrial-label {
    font-family: 'Consolas', 'Courier New', Courier, monospace;
    font-size: 0.74rem;
    margin-bottom: 0px;
}

.industrial-value {
    font-family: 'Consolas', 'Courier New', Courier, monospace;
    font-size: 0.85rem;
}
</style>
